// Determines whether the target is a function
export const isFun = (target: any) => typeof target === 'function';
